import { render, staticRenderFns } from "./columnSetting.vue?vue&type=template&id=a303cf1a&scoped=true&"
import script from "./columnSetting.vue?vue&type=script&lang=js&"
export * from "./columnSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a303cf1a",
  null
  
)

export default component.exports